var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [
          _vm._v(
            "\n        Valor a pagar " +
              _vm._s(
                _vm.moneyFormat(_vm.modelValue.pago.amt_total_a_pagar, 2)
              ) +
              "\n         \n        Valor digitado " +
              _vm._s(_vm.moneyFormat(_vm.valor, 2)) +
              "\n      "
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  stretch: "",
                  vMoney: "",
                  format: _vm.money,
                  id: "efectivo",
                  placeholder: "##.##"
                },
                model: {
                  value: _vm.modelValue.pago.efectivo,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue.pago, "efectivo", $$v)
                  },
                  expression: "modelValue.pago.efectivo"
                }
              },
              [_c("span", [_vm._v("Efectivo")])]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  stretch: "",
                  vMoney: "",
                  format: _vm.money,
                  id: "transferencia",
                  placeholder: "##.##"
                },
                model: {
                  value: _vm.modelValue.pago.transferencia,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue.pago, "transferencia", $$v)
                  },
                  expression: "modelValue.pago.transferencia"
                }
              },
              [_c("span", [_vm._v("Transferencia")])]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  stretch: "",
                  vMoney: "",
                  format: _vm.money,
                  id: "deposito",
                  placeholder: "##.##"
                },
                model: {
                  value: _vm.modelValue.pago.deposito,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue.pago, "deposito", $$v)
                  },
                  expression: "modelValue.pago.deposito"
                }
              },
              [_c("span", [_vm._v("Depósito")])]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  stretch: "",
                  id: "ref_deposito",
                  placeholder: "##.##"
                },
                model: {
                  value: _vm.modelValue.pago.ref_deposito,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue.pago, "ref_deposito", $$v)
                  },
                  expression: "modelValue.pago.ref_deposito"
                }
              },
              [_c("span", [_vm._v("Referencia depósito")])]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-8" }, [
        _c("div", { staticClass: "form-field" }, [
          _c(
            "div",
            { staticClass: "datepicker-field" },
            [
              _c("VueCtkDateTimePicker", {
                attrs: {
                  id: "fecha_proximo_pago",
                  locale: "es",
                  "no-label": "",
                  "only-date": "",
                  "button-now-translation": "Ahora",
                  format: "YYYY-MM-DD",
                  formatted: "YYYY-MM-DD",
                  label: "Seleccione una fecha...",
                  noClearButton: "",
                  "disabled-weekly": [0]
                },
                model: {
                  value: _vm.modelValue.fecha_proximo_pago,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "fecha_proximo_pago", $$v)
                  },
                  expression: "modelValue.fecha_proximo_pago"
                }
              }),
              _vm._v(" "),
              _c("label", [_vm._v("Generar recibo pago adelantado")])
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c("div", { staticClass: "form-field" }, [
          _c(
            "div",
            { staticClass: "file-upload-field" },
            [
              _c("label", [_vm._v("Archivo")]),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.modelValue.pago.url_archivo != null ||
                        _vm.modelValue.pago.archivo != null,
                      expression:
                        "modelValue.pago.url_archivo != null || modelValue.pago.archivo != null"
                    }
                  ],
                  staticClass: "btn-warning",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.eliminarArchivo()
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-trash" })]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.modelValue.pago.url_archivo != null &&
                        _vm.modelValue.pago.archivo == null,
                      expression:
                        "modelValue.pago.url_archivo != null && modelValue.pago.archivo == null"
                    }
                  ],
                  staticClass: "btn-info",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.descargarArchivo()
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-download" })]
              ),
              _vm._v(" "),
              _c("fileUpload", {
                ref: "archivo",
                attrs: {
                  id: "archivo",
                  extensiones: ".JPEG,.gif,.jpg,.png,.PNG,.JPG",
                  defaultImage:
                    _vm.modelValue.pago.url_archivo != null
                      ? _vm.modelValue.pago.url_archivo
                      : "/images/no-logo.png",
                  pathDefault: "/images/no-logo.png",
                  tamanoMaximo: 5000000,
                  descripcionMaximo: "5mb",
                  verMiniatura: ""
                },
                on: {
                  imagenCargada: function($event) {
                    return _vm.setearArchivo()
                  }
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-xs-12 col-md-8" },
        [
          _c(
            "textarea-field",
            {
              attrs: {
                placeholder: "Escriba una observación",
                id: "observaciones"
              },
              model: {
                value: _vm.modelValue.pago.observaciones,
                callback: function($$v) {
                  _vm.$set(_vm.modelValue.pago, "observaciones", $$v)
                },
                expression: "modelValue.pago.observaciones"
              }
            },
            [_c("span", [_vm._v("Observaciones")])]
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-buttons" }, [
      _c("button", { staticClass: "btn-success", on: { click: _vm.abonar } }, [
        _c("i", { staticClass: "fa fa-save" }),
        _c("span", [_vm._v("Abonar")])
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-danger btn--text",
          on: {
            click: function($event) {
              return _vm.$emit("cerrar")
            }
          }
        },
        [
          _c("i", { staticClass: "fa fa-times" }),
          _c("span", [_vm._v("Cancelar")])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ef15be1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ef15be1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/prestamos/cobros/ModalAmtPago.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4ef15be1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/prestamos/cobros/ModalAmtPago.vue
// module chunks = 0